<template>
  <Header />
  <router-view/>
  <Loader />
  <Cookies />
  <CookiesModal />
  <LoginModal />
  <DeleteAccountModal />
</template>

<script>
import Header from '@/components/Header.vue'
import Loader from '@/components/Loader.vue'
import Cookies from '@/components/Cookies.vue'
import CookiesModal from '@/components/CookiesModal.vue'
import LoginModal from '@/components/LoginModal.vue'
import DeleteAccountModal from '@/components/DeleteAccountModal.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Header,
    Loader,
    Cookies,
    CookiesModal,
    LoginModal,
    DeleteAccountModal
  },
  computed: {
    ...mapState(['codeLangs'])
  },
  methods: {
    ...mapActions(['getChangeLanguages'])
  },
  created () {
    this.getChangeLanguages(this.codeLangs[0])
    document.title = 'Concurso Bar Manager'
  }
}
</script>

<style>
#app {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:root {
  --primary: #000000;
  --star: #DDA800;
}
</style>
